import { render, staticRenderFns } from "./commonBackHeader.vue?vue&type=template&id=6da8d9a2&scoped=true"
import script from "./commonBackHeader.vue?vue&type=script&lang=js"
export * from "./commonBackHeader.vue?vue&type=script&lang=js"
import style0 from "./commonBackHeader.vue?vue&type=style&index=0&id=6da8d9a2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8d9a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6da8d9a2')) {
      api.createRecord('6da8d9a2', component.options)
    } else {
      api.reload('6da8d9a2', component.options)
    }
    module.hot.accept("./commonBackHeader.vue?vue&type=template&id=6da8d9a2&scoped=true", function () {
      api.rerender('6da8d9a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonBackHeader.vue"
export default component.exports